export type ChangeEventLike<Value = string> = {
  target: {
    name?: string;
    id?: string;
    value: Value;
  } & (Value extends boolean ? { checked: boolean } : unknown);
};

export function buildChangeEventLike<Value = string>(
  target: ChangeEventLike<Value>['target'],
): ChangeEventLike<Value> {
  return {
    target,
  };
}
